import { WireCompanyModelDto } from '@treasury/api/channel';

export const nullWireCompany: WireCompanyModelDto = {
    name: '',
    isDliWireCompany: false,
    id: 0,
    updatedBy: '',
    updatedDate: '0001-01-01T00:00:00',
};
